<script>
import { PolarArea } from 'vue-chartjs'
import { mapGetters } from 'vuex'
import { chartData, chartOptions } from '@/config/charts'

export default {
  extends: PolarArea,
  name: 'PolarArea',
  props: {
    loaded: {
      type: Boolean,
      default: false
    },
    selectedOlymp: {
      type: Number,
      default() {
        return null
      }
    },
    typeStats: {
      type: String,
      default: null
    }
  },
  beforeDestroy() {
    this.chartData.labels = []
    this.chartData.datasets[0].data = []
  },
  watch: {
    selectedOlymp() {
      this.getChart()
    }
  },
  data() {
    return {
      regionSelected: null,
      chartData: chartData,
      maxValue: 0
    }
  },
  mounted() {
    this.getChart()
  },
  methods: {
    getChart() {
      this.chartData.labels = []
      this.chartData.datasets[0].data = []
      this.maxValue = 0
      const options = {
        ...chartOptions,
        plugins: {
          datalabels: {
            color: () => 'white',
            formatter: (value, context) => ((context.chart.data.datasets[0].data[context.dataIndex] > 35 * (this.maxValue / 100)) ? context.chart.data.datasets[0].data[context.dataIndex] : '')
          }
        }
      }
      if (this.typeStats === 'count') {
        this.statsOlympicsResults.sort(this.sortByCount)
        for (let i = 0; i < this.statsOlympicsResults.length; i++) {
          const classStats = this.gpClasses.find((p) => p.id
            === this.statsOlympicsResults[i].organizationId && p.position && p.classesCount)
          if (classStats) {
            if (classStats.title.length > 57) {
              this.chartData.labels.push(`${classStats.title.slice(0, 57)}...`)
            } else {
              this.chartData.labels.push(classStats.title)
            }
            const percentParticipants = Math.ceil((this.statsOlympicsResults[i].membersOlymp
              / this.statsOlympicsResults[i].membersClass) * 100)
            this.chartData.datasets[0].data.push(percentParticipants)
            if (percentParticipants > this.maxValue) {
              this.maxValue = percentParticipants
            }
          }
        }
      } else if (this.typeStats === 'progress') {
        this.statsOlympicsResults.sort(this.sortByProgress)
        for (let i = 0; i < this.statsOlympicsResults.length; i++) {
          const classStats = this.gpClasses.find((p) => p.id
            === this.statsOlympicsResults[i].organizationId && p.position && p.classesCount)
          if (classStats) {
            if (classStats.title.length > 57) {
              this.chartData.labels.push(`${classStats.title.slice(0, 57)}...`)
            } else {
              this.chartData.labels.push(classStats.title)
            }
            this.chartData.datasets[0].data.push(Math.ceil(this
              .statsOlympicsResults[i].averageProgress))
            if (Math.ceil(this.statsOlympicsResults[i].averageProgress) > this.maxValue) {
              this.maxValue = Math.ceil(this.statsOlympicsResults[i].averageProgress)
            }
          }
        }
      }
      this.renderChart({
        labels: this.chartData.labels,
        datasets: this.chartData.datasets
      }, options)
    },
    sortByProgress(class1, class2) {
      return class2.averageProgress - class1.averageProgress
    },
    sortByCount(class1, class2) {
      return (class2.membersOlymp / class2.membersClass)
        - (class1.membersOlymp / class1.membersClass)
    }
  },
  computed: {
    ...mapGetters({
      gpClasses: 'content/getGPClasses',
      statsOlympicsResults: 'statistics/getStatsOlympicsResults'
    })
  }
}
</script>

<style scoped>

</style>
